const unavailableCodes = new Set([
  'auth/api-key-expired',
  'auth/invalid-api-key',
  'auth/internal-error',
  'auth/network-request-failed',
]);

export const formatAuthErrorMessage = (error, messages) => {
  const code = typeof error?.code === 'string' ? error.code : '';

  if (unavailableCodes.has(code)) {
    return messages.serviceUnavailable;
  }

  if (code === 'auth/too-many-requests') {
    return messages.rateLimited;
  }

  return messages.fallback;
};

